import { FillLogoIcon } from '@/shared/modules/Icons/componentes/fill/FillLogoIcon';
import { LogoProps } from '@/shared/types/logo';
import { logoSizePxMap } from './constants/size';

/**
 * Logo - Componente de logo de la aplicación
 *
 * Renderiza el logotipo de marca como SVG (`FillLogoIcon`).
 * Soporta diferentes tamaños predefinidos.
 *
 * @example
 * ```tsx
 * // Logo por defecto (sm)
 * <Logo />
 *
 * // Otros tamaños
 * <Logo size="md" />
 * <Logo size="lg" />
 * ```
 *
 * @see {@link LogoProps} para la lista completa de props
 */
export const Logo = ({ size = 'sm' }: LogoProps) => {
  const px = logoSizePxMap[size];
  return <FillLogoIcon width={px} height={px} role="img" aria-label="Logo" />;
};
